import React from 'react';

const TeamMember = ({ firstName, lastName, title, linkedin, img }) => (
  <div className="col-md-4">
    <div className="team-member">
      <img className="mx-auto rounded-circle" src={'img/team/' + img} alt="" />
      <h4>{firstName + ' ' + lastName}</h4>
      <p>{title}</p>
      <div className="social-buttons">
        <a href={linkedin} target="_blank" rel="noopener noreferrer">
          <i className="fab text-white fa-linkedin-in" />
        </a>
      </div>
    </div>
  </div>
);
export default TeamMember;
